export default {
	fundattio_main_url: 'https://minervia.innogement.com',
	fundattio_service_url: 'https://minervia.innogement.com/api/v1/',
    fundattio_gtag_id: 'X-XXXXXXXXXX',
    version: '1.0.0'
};